import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, CheckCircleIcon, LoaderIcon } from 'lucide-react';
const PHOENIX_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/d364c66c-2016-44c1-a772-51bca11dc3ea.jpg';
type Status = 'idle' | 'loading' | 'success';
export function DownloadCTA() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Por favor, escribe un correo válido.');
      return;
    }
    setError('');
    setStatus('loading');
    setTimeout(() => setStatus('success'), 1200);
  };
  return <section id="descargar" className="relative w-full overflow-hidden bg-[#3a2e28] px-6 py-20 sm:py-28" data-id="element-47" data-mp="2sjas4lxjzztb">
      <img src={PHOENIX_IMG} alt="" aria-hidden="true" className="pointer-events-none absolute -right-16 top-1/2 hidden w-72 -translate-y-1/2 opacity-15 mix-blend-screen sm:block" data-id="element-48" data-mp="2nkfzytdp4ywj" />
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.7
    }} className="relative mx-auto max-w-xl text-center text-[#f3e9dd]" data-id="element-49" data-mp="3ub4lb6pr9cw9">
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-[#c9a24b]" data-id="element-50" data-mp="37bq9eu5px8ty">
          Descarga tu guía gratuita ahora
        </p>
        <h2 className="font-serif text-3xl font-medium leading-tight sm:text-4xl" data-id="element-51" data-mp="3be3ctbwzsunk">
          5 Días Para Encontrar Tu Equilibrio
        </h2>
        <p className="mt-3 font-serif text-lg italic text-[#e6d8ca]" data-id="element-52" data-mp="3ge7u345q5teu">
          Aunque el mundo esté en caos.
        </p>

        {status === 'success' ? <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="mx-auto mt-10 max-w-md rounded-2xl bg-[#b06a4a]/20 p-8" data-id="element-53" data-mp="vkurk8m9cffc">
            <CheckCircleIcon className="mx-auto h-10 w-10 text-[#c9a24b]" data-id="element-54" data-mp="5xsca9nc0du5" />
            <p className="mt-4 font-serif text-xl" data-id="element-55" data-mp="5zuysjp9zou4">Tu guía está en camino.</p>
            <p className="mt-2 text-sm text-[#e6d8ca]" data-id="element-56" data-mp="ktpzv3j6w9ur">
              Revisa tu correo — te enviamos un abrazo digital con los 5 días.
            </p>
          </motion.div> : <form onSubmit={handleSubmit} className="mx-auto mt-10 max-w-md" noValidate data-id="element-57" data-mp="3oct3f3x0j5um">
            <div className="flex flex-col gap-3 sm:flex-row" data-id="element-58" data-mp="3jdg8rwzwguhh">
              <label htmlFor="email" className="sr-only" data-id="element-59" data-mp="1w6qfystkp7t">
                Tu correo electrónico
              </label>
              <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@correo.com" disabled={status === 'loading'} className="w-full rounded-full border border-white/15 bg-white/10 px-6 py-4 text-sm text-[#faf4ec] placeholder-[#e6d8ca]/60 outline-none transition focus:border-[#c9a24b] focus:ring-2 focus:ring-[#c9a24b]/40 disabled:opacity-60" data-id="element-60" data-mp="3tb4ax7zu549o" />
              <button type="submit" disabled={status === 'loading'} className="inline-flex flex-shrink-0 items-center justify-center gap-2 rounded-full bg-[#b06a4a] px-7 py-4 text-sm font-semibold uppercase tracking-wider text-[#faf4ec] transition-colors hover:bg-[#a25e40] disabled:opacity-70" data-id="element-61" data-mp="166qdpqqkl28o">
                {status === 'loading' ? <>
                    <LoaderIcon className="h-4 w-4 animate-spin" data-id="element-62" data-mp="1ptehkswe6lir" />
                    Enviando…
                  </> : <>
                    <DownloadIcon className="h-4 w-4" data-id="element-63" data-mp="eej6ti0v947h" />
                    Descargar gratis
                  </>}
              </button>
            </div>
            {error && <p className="mt-3 text-sm text-[#f0c9b8]" role="alert" data-id="element-64" data-mp="yo0wbey56ohp">
                {error}
              </p>}
            <p className="mt-5 text-xs leading-relaxed text-[#e6d8ca]/80" data-id="element-65" data-mp="tw0nsy40an9i">
              Sin costo. Sin compromiso. Solo un abrazo digital de venezolana a
              venezolano.
            </p>
          </form>}
      </motion.div>
    </section>;
}